import type {
	CoursesAnswerAmaDto,
	CoursesListAdminAmaQueryDto,
	CoursesSetAmaStatusDto,
} from '@sportspredict/shared';
import type { Wire } from '../../types/common.types';
import { coursesApi } from './courses-base.api';
import type {
	ListAdminAmaCoursesOutput,
	ListAdminAmaInput,
	ListAdminAmaOutput,
	AnswerAmaInput,
	AnswerAmaOutput,
	SetAmaStatusInput,
	SetAmaStatusOutput,
	GetAmaCountsOutput,
} from '../../types/admin-ama.types';

const TAG = 'courses:admin-ama' as const;
const INVALIDATES = [TAG, 'courses:office-hours'] as const;

export const adminAmaEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		listAdminAmaCourses: builder.query<ListAdminAmaCoursesOutput, void>({
			query: () => ({ url: 'courses/admin/ama/courses' }),
			providesTags: [TAG],
		}),
		listAdminAma: builder.query<ListAdminAmaOutput, ListAdminAmaInput>({
			query: (params) => ({
				url: 'courses/admin/ama',
				params: params satisfies Wire<CoursesListAdminAmaQueryDto>,
			}),
			providesTags: [TAG],
		}),
		answerAma: builder.mutation<AnswerAmaOutput, AnswerAmaInput>({
			query: ({ id, ...body }) => ({
				url: `courses/admin/ama/${encodeURIComponent(id)}/answer`,
				method: 'POST',
				body: body satisfies Wire<CoursesAnswerAmaDto>,
			}),
			invalidatesTags: [...INVALIDATES],
		}),
		setAmaStatus: builder.mutation<SetAmaStatusOutput, SetAmaStatusInput>({
			query: ({ id, ...body }) => ({
				url: `courses/admin/ama/${encodeURIComponent(id)}/status`,
				method: 'PATCH',
				body: body satisfies Wire<CoursesSetAmaStatusDto>,
			}),
			invalidatesTags: [...INVALIDATES],
		}),
		getAmaCounts: builder.query<GetAmaCountsOutput, void>({
			query: () => ({ url: 'courses/admin/ama/counts' }),
			providesTags: [TAG],
		}),
	}),
});

export const {
	useListAdminAmaCoursesQuery,
	useLazyListAdminAmaCoursesQuery,
	useListAdminAmaQuery,
	useLazyListAdminAmaQuery,
	useAnswerAmaMutation,
	useSetAmaStatusMutation,
	useGetAmaCountsQuery,
	useLazyGetAmaCountsQuery,
} = adminAmaEndpoints;
